module.exports = __webpack_public_path__ + "static/media/PreviewIcon.9bfcde9b.svg";